import React, { Component } from "react";
import { HashRouter, NavLink, Route, Switch } from "react-router-dom";
import superagent from "superagent";
import Home from "./Home";
import Microsoft from "./codeandtech/Microsoft";
import Opensource from "./codeandtech/Opensource";
import AWSDedication from "./codeandtech/AWSDedication";
import LearnToCode from "./codeandtech/LearnToCode";
import GIT from "./codeandtech/GIT";
import Overview from "./cloudopsguru/Overview";
import CoreServices from "./cloudopsguru/CoreServices";
import Storage from "./cloudopsguru/Storage";
import Network from "./cloudopsguru/Network";
import Messaging from "./cloudopsguru/Messaging";
import DeployOrchestration from "./cloudopsguru/DeployOrchestration";
import MLOverview from "./cloudopsguru/MLOverview";
import AzureOverview from "./cloudopsguru/AzureOverview";
import Others from "./cloudopsguru/Others";
import DataAnalytics from "./cloudopsguru/DataAnalytics";
import "../js/loader.js";
import "../js/readmeConstant.js";
import "../js/appConstants.js";

const catNavigation = [
  ["/", "Home", true],
  ["/Microsoft", "Microsoft"],
  ["/Opensource", "Open Source"],
  ["/AWSDedication", "CloudOpsGuru"],
  ["/LearnToCode", "Learn"],
  ["/GIT", "Git It"]
];

const cogNavigation = [
  ["/", "Home", true],
  ["/Overview", "Overview"],
  ["/CoreServices", "Core services"],
  ["/Storage", "Storage"],
  ["/DataAnalytics", "Data & AI"],
  ["/Network", "Network"],
  ["/Messaging", "Messaging"],
  ["/DeployOrchestration", "Deploy"],
  ["/MLOverview", "ML"],
  ["/Others", "More"],
  ["/AzureOverview", "Azure"]
];

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      githubreadmes: window.readmeConstant,
      appConstants: window.appConstants,
      blogUrl: window.appConstants.blogUrl
    };
    window.clickLog("load", "homepage");
  }

  componentDidMount() {
    const isCat = this.state.appConstants.AppName === "CodeAndTech";
    document.title = isCat
      ? "CodeAndTech | Build, Learn, Create"
      : "CloudOpsGuru | Cloud Notes & Learning";
    this.getCodeAndTechReadmes();
  }

  getCodeAndTechReadmes() {
    superagent
      .get(this.state.appConstants.CodeAndTechReadmesUrl)
      .set("Accept", "application/json")
      .end((error, response) => {
        if (!error && response && response.text) {
          try {
            const data = JSON.parse(response.text);
            if (data && data.tabs) this.setState({ githubreadmes: data });
          } catch (ignored) {
            // The embedded README data remains available when the service is unavailable.
          }
        }
      });
  }

  openBlog = () => {
    window.clickLog("load", "blog");
    window.open(this.state.blogUrl, "_blank", "noopener,noreferrer");
  };

  renderCatRoutes() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/Microsoft" component={Microsoft} />
        <Route path="/Opensource" component={Opensource} />
        <Route path="/AWSDedication" component={AWSDedication} />
        <Route path="/LearnToCode" render={(props) => <LearnToCode {...props} GithubReadmes={this.state.githubreadmes} />} />
        <Route path="/GIT" component={GIT} />
      </Switch>
    );
  }

  renderCogRoutes() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/Overview" component={Overview} />
        <Route path="/CoreServices" component={CoreServices} />
        <Route path="/Storage" component={Storage} />
        <Route path="/DataAnalytics" component={DataAnalytics} />
        <Route path="/Network" component={Network} />
        <Route path="/Messaging" component={Messaging} />
        <Route path="/DeployOrchestration" component={DeployOrchestration} />
        <Route path="/MLOverview" component={MLOverview} />
        <Route path="/Others" component={Others} />
        <Route path="/AzureOverview" component={AzureOverview} />
      </Switch>
    );
  }

  render() {
    const isCat = this.state.appConstants.AppName === "CodeAndTech";
    const navigation = isCat ? catNavigation : cogNavigation;
    const brand = isCat ? "CodeAndTech" : "CloudOpsGuru";
    const eyebrow = isCat ? "DEVELOPER NOTES" : "CLOUD LEARNING HUB";

    return (
      <HashRouter>
        <div className={`site-shell ${isCat ? "site-shell--cat" : "site-shell--cog"}`}>
          <header className="site-header">
            <NavLink exact to="/" className="brand" aria-label={`${brand} home`}>
              <span className="brand__mark">{isCat ? "</>" : "☁"}</span>
              <span>
                <span className="brand__eyebrow">{eyebrow}</span>
                <span className="brand__name">{brand}</span>
              </span>
            </NavLink>
            <nav className="primary-nav" aria-label="Primary navigation">
              {navigation.map(([path, label, exact]) => (
                <NavLink key={path} exact={exact} to={path} activeClassName="is-active">
                  {label}
                </NavLink>
              ))}
            </nav>
            <button className="blog-button" type="button" onClick={this.openBlog}>
              Visit blog <span aria-hidden="true">↗</span>
            </button>
          </header>
          <main className="site-content">
            {isCat ? this.renderCatRoutes() : this.renderCogRoutes()}
          </main>
          <footer className="site-footer">
            <span>{brand}</span>
            <span>Built for curious minds.</span>
          </footer>
        </div>
      </HashRouter>
    );
  }
}
